"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBox = exports.StyledIconButton = exports.CopyContentIcon = void 0;
const Box_1 = __importDefault(require("@mui/material/Box"));
const ButtonBase_1 = require("@mui/material/ButtonBase");
const styles_1 = require("@mui/material/styles");
const icon_button_1 = __importDefault(require("../icon-button"));
const CopyContent_1 = __importDefault(require("../icon/svgs/CopyContent"));
exports.CopyContentIcon = (0, styles_1.styled)(CopyContent_1.default)(({ theme }) => ({
    "&, & path": {
        fill: theme.colours.inter
    },
    "&:hover": {
        cursor: "pointer"
    }
}));
exports.StyledIconButton = (0, styles_1.styled)(icon_button_1.default)({
    backgroundColor: "unset",
    padding: 0,
    ":hover": {
        backgroundColor: "unset"
    },
    [`.${ButtonBase_1.touchRippleClasses.root}`]: {
        zIndex: 3
    }
});
exports.StyledBox = (0, styles_1.styled)(Box_1.default)({
    display: "inline-block"
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvcHktdG8tY2xpcGJvYXJkLWJ1dHRvbi9zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsNERBQW9DO0FBQ3BDLHlEQUE4RDtBQUM5RCxpREFBOEM7QUFDOUMsaUVBQXdDO0FBQ3hDLDJFQUFtRDtBQUV0QyxRQUFBLGVBQWUsR0FBRyxJQUFBLGVBQU0sRUFBQyxxQkFBVyxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ2pFLFdBQVcsRUFBRTtRQUNYLElBQUksRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7S0FDMUI7SUFDRCxTQUFTLEVBQUU7UUFDVCxNQUFNLEVBQUUsU0FBUztLQUNsQjtDQUNGLENBQUMsQ0FBQyxDQUFDO0FBRVMsUUFBQSxnQkFBZ0IsR0FBRyxJQUFBLGVBQU0sRUFBQyxxQkFBVSxDQUFDLENBQUM7SUFDakQsZUFBZSxFQUFFLE9BQU87SUFDeEIsT0FBTyxFQUFFLENBQUM7SUFDVixRQUFRLEVBQUU7UUFDUixlQUFlLEVBQUUsT0FBTztLQUN6QjtJQUNELENBQUMsSUFBSSwrQkFBa0IsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxFQUFFO1FBQy9CLE1BQU0sRUFBRSxDQUFDO0tBQ1Y7Q0FDRixDQUFDLENBQUM7QUFFVSxRQUFBLFNBQVMsR0FBRyxJQUFBLGVBQU0sRUFBQyxhQUFHLENBQUMsQ0FBQztJQUNuQyxPQUFPLEVBQUUsY0FBYztDQUN4QixDQUFDLENBQUMifQ==